import { Blocker } from "react-router-dom";
import SubtleButton from "../Buttons/SubtleButton";
import ModalWrapper from "./ModalWrapper";
import React from "react";

export default function BlockerDialog({
  blocker,
  message = "Do you want to save before leaving?",
  children,
}: {
  blocker: Blocker;
  children?: React.ReactNode;
  message?: string;
}) {
  if (blocker.state === "blocked") {
    return (
      <ModalWrapper clickOff={() => blocker.reset()}>
        <div className="bg-white p-5 z-10 rounded-xl flex-col items-center">
          <h2 className="text-center font-bold">{message}</h2>
          <div className="flex gap-2 mt-2 justify-end">
            <SubtleButton
              onClick={() => blocker.reset()}
              disabled={undefined}
              loading={undefined}
              loaderColor={undefined}
              loaderSize={undefined}
              label={undefined}
              className={undefined}
              testId={undefined}
              title={undefined}
              buttonRole="primary"
            >
              Stay Here
            </SubtleButton>
            <SubtleButton
              onClick={() => blocker.proceed()}
              disabled={undefined}
              loading={undefined}
              loaderColor={undefined}
              loaderSize={undefined}
              label={undefined}
              className={undefined}
              testId={undefined}
              title={undefined}
            >
              Continue
            </SubtleButton>
          </div>
        </div>
      </ModalWrapper>
    );
  }
  return null;
}
